import AppBar from '@material-ui/core/AppBar';
import api from '../../../services/api';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import {
  CardContent, FormGroup, TableCell,
  TableBody, TableHead, TableRow, Table, Button,
  Paper, Checkbox
} from '@material-ui/core';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { ANAO, ASIM } from '../../../consts';
import SendIcon from '@material-ui/icons/Send';
import TuneIcon from '@material-ui/icons/Tune';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { formatData } from '../../../lib/functions';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { CommonTranslations } from 'translations/translationKeys'
import ViewWeekIcon from '@material-ui/icons/ViewWeek';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import Autocomplete from '@material-ui/lab/Autocomplete';

function TabContainer(props) {
  return (
    <Typography
      component="div"
      style={{ padding: 8 * 3 }}
    >
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};


// Definição dos estilos
const styles = theme => ({
  textField: {
    marginTop: theme.spacing(0), // Margem superior
    marginBottom: "0.5rem", // Margem inferior
    marginRight: "0.5rem", // Margem direita
  },
  addButton: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    float: 'right', // alinhamento a direita
  },
  textarea: {
    width: '100%',
    height: '100px',
    padding: theme.spacing(1),
    boxSizing: 'border-box',
  },
  dialogContent: {
    padding: theme.spacing(2),
  },

});

class WhatsAppForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fornecedoresescalas: [],
      searchFilter: {
        tipoDataFilter: 1,
        dataInicialFilter: '',
        horaInicialFilter: '00:00',
        dataFinalFilter: '',
        horaFinalFilter: '23:59',
        guiaFilter: ASIM,
        fornecTranspFilter: ASIM,
        motoristaFilter: ASIM,
        codFornecedorFilter: 0,
        codItemEscalaFilter: '',
        codServicoFilter: 0
      },
      marcarTodos: ANAO,
      gruposmensagem: [],
      grupoMensagemEnvio: 0,
      isConnected: false,
      qrCode: "",
      intervalId: null,
      prontoEnvio: false,
      loading: false,
      labelLoading: "",
      listaFornecedores: [],
      listaServicos: [],

      activetab: 0,
      openAlert: false,
      translations: {}, // Armazenará as traduções
    };
  }

  async componentDidMount() {
    let { listaFornecedores, listaServicos } = this.state;

    const fornecedores = await api.get(`/fornecedor/active/true`);
    {
      fornecedores.data.map((fornecedor) => (
        listaFornecedores.push({ codfornecedor: fornecedor.codfornecedor, fornecedor: fornecedor.fantasia })
      ))
    };
    this.setState({ listaFornecedores: listaFornecedores });

    const servicos = await api.get(`/servico/active/true`);
    {
      servicos.data.data.map((servico) => (
        listaServicos.push({ codservico: servico.codservico, servico: servico.descservico })
      ))
    };
    this.setState({ listaServicos: listaServicos });

    const grupomensagem = await api.get(`/whatsapp/grupomensagemfornecedor/active/true`);
    this.setState({ gruposmensagem: grupomensagem.data });

    this.buscarQrCode(); // executa imediatamente
    this.intervalId = setInterval(this.buscarQrCode, 10000); // executa a cada 10s    
  };

  async componentWillUnmount() {
    clearInterval(this.intervalId); // limpa o intervalo ao sair da tela
  }

  buscarQrCode = async () => {
    let codEmpresa = sessionStorage.getItem('codEmpresa');
    try {
      const qrcode = await api.get(`/whatsapp/statusConexaoWhatsApp/${codEmpresa}`);

      if (qrcode.data.value) {
        this.setState({
          qrCode: qrcode.data.value,
          isConnected: false,
          prontoEnvio: false,
          marcarTodos: ANAO
        })
      }
      if (qrcode.data.connected) {
        this.setState({ isConnected: qrcode.data.connected })
      }

    } catch (error) {
      console.error('Erro ao buscar QR Code:', error);
    }

    this.buscarQrCode();
  };

  /* atualiza filtros na tela */
  OnChangeSearch = (event) => {
    const { searchFilter } = this.state;
    let { name, type, value, checked } = event.target;
    let adjustedValue = value;

    switch (type) {
      case 'checkbox':
        if (checked === false) {
          adjustedValue = ANAO;
        } else {
          adjustedValue = ASIM;
        }
        break;
      case 'select-one':
        adjustedValue = Number(value);
        break;
      case 'number':
        adjustedValue = Number(value);
        break;
      default:
        break;
    }

    searchFilter[name] = adjustedValue;
    this.setState({ searchFilter });
  };

  /* Pesquisa fornecedores escala */
  Pesquisa = async () => {
    this.setState({
      loading: true,
      labelLoading: 'Filtrando dados...'
    });

    const { searchFilter } = this.state;
    let codEmpresa = sessionStorage.getItem('codEmpresa');

    const filtro = {
      guia: searchFilter.guiaFilter,
      fornectransp: searchFilter.fornecTranspFilter,
      motorista: searchFilter.motoristaFilter,
      tipoperiodo: searchFilter.tipoDataFilter,
      datainicial: searchFilter.dataInicialFilter,
      horainicial: searchFilter.horaInicialFilter,
      datafinal: searchFilter.dataFinalFilter,
      horafinal: searchFilter.horaFinalFilter,
      codfornecedor: searchFilter.codFornecedorFilter,
      coditemescala: searchFilter.codItemEscalaFilter,
      codservico: searchFilter.codServicoFilter
    }

    try {
      const prontoEnvio = this.state.isConnected;
      const response = await api.post(`/escala/fornecedoresenviowhatsapp/${codEmpresa}`, filtro);
      if (response.status === 200) {
        const fornecedores = response.data.map(item => ({
          ...item,
          marcado: (((item.existewhatsapp === ASIM) && prontoEnvio) ? ASIM : ANAO)
        }));

        this.setState({
          fornecedoresescalas: fornecedores,
          prontoEnvio: prontoEnvio,
          marcarTodos: (prontoEnvio ? ASIM : ANAO),
          activetab: 1
        });
      }
    } catch (error) {
      this.handleOpenAlert(error.response.data.error);
    } finally {
      this.setState({ loading: false });
    }
  }

  /* Limpa Filtros na tela */
  LimpaFiltros = () => {
    let { searchFilter } = this.state;
    searchFilter.tipoDataFilter = 1;
    searchFilter.dataInicialFilter = '';
    searchFilter.horaInicialFilter = '00:00';
    searchFilter.dataFinalFilter = '';
    searchFilter.horaFinalFilter = '23:59';
    searchFilter.guiaFilter = ASIM;
    searchFilter.fornecTranspFilter = ASIM;
    searchFilter.motoristaFilter = ASIM;
    searchFilter.codFornecedorFilter = 0;
    searchFilter.codItemEscalaFilter = '';
    searchFilter.codServicoFilter = 0;
    this.setState({ searchFilter });
  };

  handleChangeTab = (event, value) => {
    this.setState({ activetab: value });
  };

  /* evento on change marcar item */
  OnChangeMarcar = (event) => {
    const { fornecedoresescalas } = this.state;
    const { checked, id } = event.target;

    if (checked) {
      fornecedoresescalas[id].marcado = fornecedoresescalas[id].existewhatsapp
    } else {
      fornecedoresescalas[id].marcado = ANAO
    }

    this.setState({ fornecedoresescalas: fornecedoresescalas });
  };

  /* evento on change marcar todos */
  OnChangeMarcarTodos = (event) => {
    const { checked } = event.target;
    const { fornecedoresescalas } = this.state;

    const marcarTodos = checked ? ASIM : ANAO;

    const fornecedores = fornecedoresescalas.map(item => ({
      ...item,
      marcado: checked && (item.existewhatsapp === ASIM) ? ASIM : ANAO
    }));

    this.setState({
      fornecedoresescalas: fornecedores,
      marcarTodos
    });
  };

  handleChangeGrupoMensagem = (event) => {
    this.setState({ grupoMensagemEnvio: event.target.value });
  };

  handleClickEnviar = async () => {
    const { fornecedoresescalas, grupoMensagemEnvio } = this.state;
    let codEmpresa = sessionStorage.getItem('codEmpresa'); 
    
    // Verificação antes de continuar
    if (!grupoMensagemEnvio) {
      this.handleOpenAlert("Por favor, selecione um grupo de mensagens para envio.");
      return;
    }

    this.setState({
      loading: true,
      labelLoading: 'Enviando WhatsApp...'
    });       

    try {
      for (const fornecedor of fornecedoresescalas) {
        if (fornecedor.marcado === ASIM) {
          const body = {
            idgrupomsgwhats: Number(grupoMensagemEnvio),
            codusuarioenviou: parseInt(sessionStorage.getItem('codUser')),
            fornecedor
          };

          try {
            const response = await api.post(`/whatsapp/enviamensagemwhatsapp/${codEmpresa}`, body);
            if (response.status === 200) {
              //
            }
          } catch (error) {
            this.handleOpenAlert(error.response?.data?.error || 'Erro ao enviar mensagem');
          }
        }
      }
    } finally {
      this.setState({ loading: false }, () => {
        this.handleOpenAlert("Envio concluído.", () => {
          this.Pesquisa(); // será chamada após o usuário fechar o alerta
        });
      });
    }
  }

  handleClickDesconectar = async () => {
    let codEmpresa = sessionStorage.getItem('codEmpresa');
    try {
      const disconnect = await api.get(`/whatsapp/desconectarWhatsApp/${codEmpresa}`);

      if (qrcode.data.value) {
        this.setState({
          isConnected: false,
          prontoEnvio: false,
          marcarTodos: ANAO
        })
      }
    } catch (error) {
      console.error('Erro ao desconectar WhatsApp:', error);
    }
  }

  /* abre janela de alerta com mensagem */
  handleOpenAlert = (message, callback) => {
    this.setState({
      messageAlert: message,
      openAlert: true,
      onCloseCallback: callback
    });
  };

  /* fecha janela mensagem alerta */
  handleCloseAlert = () => {
    this.setState({ openAlert: false });
    if (this.state.onCloseCallback) {
      this.state.onCloseCallback();
    }
  }

  render() {
    const { translations } = this.state;
    const { activetab } = this.state;
    const { searchFilter } = this.state;

    const { fornecedoresescalas } = this.state;
    const { gruposmensagem, grupoMensagemEnvio } = this.state;
    const { isConnected, qrCode, prontoEnvio, loading, labelLoading } = this.state;
    const { listaFornecedores, listaServicos } = this.state;


    return (
      <div style={{ position: 'relative' }}>
        <AppBar
          color="default"
          position="static"
        >
          <Tabs
            indicatorColor="primary"
            onChange={this.handleChangeTab}
            scrollButtons="auto"
            scrollable
            textColor="primary"
            value={activetab}
          >
            <Tab
              icon={<TuneIcon />}
              label={translations[CommonTranslations.TABSHEET_GERAL] || 'Filtro'}

            />
            <Tab
              icon={<SendIcon />}
              label="Envio"
            />
            <Tab
              icon={<ViewWeekIcon />}
              id="tab3"
              label="QR Code"
            />
          </Tabs>
        </AppBar>

        {/* Aba Filtro */}
        {activetab === 0 &&
          <TabContainer>
            <CardContent>
              <Typography
                color="textSecondary"
                component="p"
                variant="body2"
              >
              </Typography>

              <Paper
                elevation={1}
                style={{
                  marginBottom: 0,
                  marginTop: 0,
                  padding: 10,
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'flex-start', // agora alinhamento por item
                  gap: 10,
                  minHeight: 64, // define a altura-base "original"
                  position: 'relative',
                }}
              >
                {/* Container que pode quebrar linha */}
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 10,
                    flex: 1, // ocupa o espaço restante
                    minWidth: 0, // importante para responsividade
                  }}
                >
                  <FormControl style={{ minWidth: 160 }}>
                    <InputLabel shrink style={{ fontSize: '13px' }}>Período</InputLabel>
                    <Select
                      native
                      inputProps={{ maxLength: 50 }}
                      value={searchFilter.tipoDataFilter || 1}
                      onChange={this.OnChangeSearch}
                      name="tipoDataFilter"
                    >
                      <option value={1}>Do serviço</option>
                      <option value={2}>De registro</option>
                    </Select>
                  </FormControl>

                  <div
                    style={{
                      display: 'flex',
                      gap: 10,
                      flexWrap: 'nowrap',
                      whiteSpace: 'nowrap', // impede quebra de linha
                    }}
                  >
                    <TextField
                      InputLabelProps={{ shrink: true, style: { fontSize: '13px' } }}
                      inputProps={{ maxLength: 50 }}
                      label="Data Inicial"
                      id="dataInicialFilter"
                      name="dataInicialFilter"
                      onChange={this.OnChangeSearch}
                      type="date"
                      value={searchFilter.dataInicialFilter || ''}
                    />

                    <TextField
                      InputLabelProps={{ shrink: true, style: { fontSize: '13px' } }}
                      inputProps={{ maxLength: 50 }}
                      label="Hora Inicial"
                      id="horaInicialFilter"
                      name="horaInicialFilter"
                      onChange={this.OnChangeSearch}
                      type="time"
                      value={searchFilter.horaInicialFilter || ''}
                    />
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      gap: 10,
                      flexWrap: 'nowrap',
                      whiteSpace: 'nowrap', // impede quebra de linha
                    }}
                  >
                    <TextField
                      InputLabelProps={{ shrink: true, style: { fontSize: '13px' } }}
                      inputProps={{ maxLength: 50 }}
                      label="Data Final"
                      id="dataFinallFilter"
                      name="dataFinalFilter"
                      onChange={this.OnChangeSearch}
                      type="date"
                      value={searchFilter.dataFinalFilter || ''}
                    />

                    <TextField
                      InputLabelProps={{ shrink: true, style: { fontSize: '13px' } }}
                      inputProps={{ maxLength: 50 }}
                      label="Hora Final"
                      id="horaFinalFilter"
                      name="horaFinalFilter"
                      onChange={this.OnChangeSearch}
                      type="time"
                      value={searchFilter.horaFinalFilter || ''}
                    />
                  </div>
                </div>

                {/* Botões - fixos na primeira linha à direita */}
                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                    flexShrink: 0,
                    whiteSpace: 'nowrap',
                    alignSelf: 'flex-start', // força alinhamento ao topo
                    paddingTop: 6, // ajuste fino vertical (igual ao que teria no centro)
                  }}
                >
                  <Button
                    color="primary"
                    id="pesquisar"
                    onClick={this.Pesquisa}
                  >
                    <SearchIcon />
                  </Button>

                  <Button
                    color="primary"
                    onClick={() => this.LimpaFiltros()}
                  >
                    <ClearAllIcon />
                  </Button>
                </div>
              </Paper>

              <Paper
                elevation={1}
                style={{
                  marginBottom: 0,
                  marginTop: 10,
                  paddingLeft: 10,
                  paddingTop: 10
                }}
              >
                <Typography style={{ fontSize: '12px' }}>
                  Categorias
                </Typography>

                <FormGroup row={true}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={(searchFilter.guiaFilter === ASIM)}
                          name="guiaFilter"
                          onChange={this.OnChangeSearch}
                          color="primary"
                        />}
                      label={'Guias'}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={(searchFilter.fornecTranspFilter === ASIM)}
                          name="fornecTranspFilter"
                          onChange={this.OnChangeSearch}
                          color="primary"
                        />}
                      label={'Fornecedores de Transporte'}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={(searchFilter.motoristaFilter === ASIM)}
                          name="motoristaFilter"
                          onChange={this.OnChangeSearch}
                          color="primary"
                        />}
                      label={'Motoristas'}
                    />
                  </FormGroup>
                </FormGroup>

              </Paper>

              <Paper
                elevation={1}
                style={{
                  marginBottom: 0,
                  marginTop: 10,
                  padding: 10,
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'flex-start', // agora alinhamento por item
                  gap: 10,
                  minHeight: 64, // define a altura-base "original"
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    flexWrap: 'wrap',
                    gap: 10,
                  }}
                >
                  <div style={{ display: 'inline-block' }}>
                    <Autocomplete
                      id="combo-fornecedor"
                      options={listaFornecedores}
                      getOptionLabel={(option) => option.fornecedor}
                      value={listaFornecedores.find(item => item.codfornecedor === searchFilter.codFornecedorFilter) || null}
                      onChange={(event, newValue) => {
                        this.OnChangeSearch({
                          target: {
                            name: 'codFornecedorFilter',
                            value: newValue ? newValue.codfornecedor : 0,
                            type: 'select-one'
                          }
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Fornecedor"
                          variant="standard"
                          style={{ minWidth: 300 }}
                        />
                      )}
                      openOnFocus
                      disableClearable={false}
                      disablePortal={true}
                    />
                  </div>

                  <TextField
                    id="codItemEscalaFilter"
                    name="codItemEscalaFilter"
                    label="Escala"
                    variant="standard"
                    type="number"
                    value={searchFilter.codItemEscalaFilter}
                    onChange={this.OnChangeSearch}
                    style={{ width: 100 }}
                  />

                  <div style={{ display: 'inline-block' }}>
                    <Autocomplete
                      id="combo-servico"
                      options={listaServicos}
                      getOptionLabel={(option) => option.servico}
                      value={listaServicos.find(item => item.codservico === searchFilter.codServicoFilter) || null}
                      onChange={(event, newValue) => {
                        this.OnChangeSearch({
                          target: {
                            name: 'codServicoFilter',
                            value: newValue ? newValue.codservico : 0,
                            type: 'select-one'
                          }
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Serviço"
                          variant="standard"
                          style={{ minWidth: 300 }}
                        />
                      )}
                      openOnFocus
                      disableClearable={false}
                      disablePortal={true}
                    />
                  </div>
                </div>
              </Paper>
            </CardContent>
          </TabContainer>}

        {/* Aba Envio */}
        {activetab === 1 &&
          <TabContainer>
            <div >
              <Box display="flex" alignItems="bottom" gap={2}>
                <FormControl style={{ minWidth: 250 }}>
                  <Autocomplete
                    options={gruposmensagem}
                    getOptionLabel={(option) => option.nome}
                    value={gruposmensagem.find(item => item.idgrupomsgwhats === grupoMensagemEnvio) || null}
                    onChange={(event, newValue) => {
                      this.handleChangeGrupoMensagem({
                        target: {
                          value: newValue ? newValue.idgrupomsgwhats : 0
                        }
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Grupo de mensagens para envio"
                        variant="standard"
                        style={{ minWidth: 300 }}
                      />
                    )}
                    disableClearable={false}
                  />
                </FormControl>

                <Button
                  variant="contained"
                  style={{
                    backgroundColor: prontoEnvio ? "#25D366" : "#ccc", // verde se pronto, cinza se não
                    color: "#fff",              // branco se pronto, preto se não
                    marginLeft: 16
                  }}
                  startIcon={<WhatsAppIcon style={{ color: "#fff" }} />}
                  onClick={this.handleClickEnviar}
                  disabled={!prontoEnvio}
                >
                  Enviar
                </Button>

                {!isConnected && (
                  <Typography variant="body2" style={{ fontStyle: 'italic', color: '#888', marginLeft: 5 }}>
                    *WhatsApp não conectado
                  </Typography>
                )}

                {(isConnected && (fornecedoresescalas.length > 0) && !prontoEnvio) && (
                  <Typography variant="body2" style={{ fontStyle: 'italic', color: '#888', marginLeft: 5 }}>
                    *necessário carregar dados novamente para envio
                  </Typography>
                )}
              </Box>

              <div
                style={{
                  marginTop: 10,
                  maxHeight: 500,
                  overflowY: 'auto',
                  borderTop: '2px solid #ccc',
                  borderBottom: '2px solid #ccc'
                }}>
                <Table
                  stickyHeader
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: '#fafafa',
                          paddingTop: 4,
                          paddingBottom: 4
                        }}
                      >
                        <Typography
                          color="textSecondary"
                          component="p"
                          variant="body2"
                        >
                          <Checkbox
                            color="primary"
                            checked={(this.state.marcarTodos === ASIM)}
                            onChange={this.OnChangeMarcarTodos}
                            disabled={!prontoEnvio}
                          />
                        </Typography>
                      </TableCell>

                      <TableCell
                        style={{
                          backgroundColor: '#fafafa',
                          paddingTop: 4,
                          paddingBottom: 4
                        }}
                      >
                        <Typography
                          color="textSecondary"
                          component="p"
                          variant="body2"
                        >
                          Categoria
                        </Typography>
                      </TableCell>

                      <TableCell
                        style={{
                          backgroundColor: '#fafafa',
                          paddingTop: 4,
                          paddingBottom: 4
                        }}
                      >
                        <Typography
                          color="textSecondary"
                          component="p"
                          variant="body2"
                        >
                          Fornecedor
                        </Typography>
                      </TableCell>

                      <TableCell
                        style={{
                          backgroundColor: '#fafafa',
                          paddingTop: 4,
                          paddingBottom: 4
                        }}
                      >
                        <Typography
                          color="textSecondary"
                          component="p"
                          variant="body2"
                        >
                          Fone
                        </Typography>
                      </TableCell>

                      <TableCell
                        style={{
                          backgroundColor: '#fafafa',
                          paddingTop: 4,
                          paddingBottom: 4
                        }}
                      >
                        <Typography
                          color="textSecondary"
                          component="p"
                          variant="body2"
                        >
                          Escala
                        </Typography>
                      </TableCell>

                      <TableCell
                        style={{
                          backgroundColor: '#fafafa',
                          paddingTop: 4,
                          paddingBottom: 4
                        }}
                      >
                        <Typography
                          color="textSecondary"
                          component="p"
                          variant="body2"
                        >
                          Data serviço
                        </Typography>
                      </TableCell>

                      <TableCell
                        style={{
                          backgroundColor: '#fafafa',
                          paddingTop: 4,
                          paddingBottom: 4
                        }}
                      >
                        <Typography
                          color="textSecondary"
                          component="p"
                          variant="body2"
                        >
                          Serviço
                        </Typography>
                      </TableCell>

                      <TableCell
                        style={{
                          backgroundColor: '#fafafa',
                          paddingTop: 4,
                          paddingBottom: 4
                        }}
                      >
                        <Typography
                          color="textSecondary"
                          component="p"
                          variant="body2"
                        >
                          Status
                        </Typography>
                      </TableCell>

                      <TableCell
                        style={{
                          backgroundColor: '#fafafa',
                          paddingTop: 4,
                          paddingBottom: 4
                        }}
                      >
                        <Typography
                          color="textSecondary"
                          component="p"
                          variant="body2"
                        >
                          Grupo de mensagens
                        </Typography>
                      </TableCell>

                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fornecedoresescalas.map((fornecedor, index) => (
                      <TableRow key={index}>
                        <TableCell align="left" width="1">
                          <Checkbox
                            color="primary"
                            checked={((fornecedor.marcado === ASIM) && (prontoEnvio))}
                            onChange={this.OnChangeMarcar}
                            id={index}
                            disabled={!prontoEnvio}
                          />
                        </TableCell>
                        <TableCell align="left" width="5">{fornecedor.categoria}</TableCell>
                        <TableCell align="left" width="5">{fornecedor.nomefornecedor}</TableCell>
                        <TableCell
                          align="left"
                          width="100"
                          style={{
                            textDecoration: fornecedor.existewhatsapp === ASIM ? 'none' : 'line-through'
                          }}
                        >
                          {fornecedor.fone}
                        </TableCell>
                        <TableCell align="left" width="5">{fornecedor.coditemescala}</TableCell>
                        <TableCell align="left" width="5">{formatData(fornecedor.dataservico)}</TableCell>
                        <TableCell align="left" width="5">{fornecedor.descservico}</TableCell>
                        <TableCell align="center" width="5">
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="100%" // garante centralização vertical
                          >
                            <Box
                              component="span"
                              style={{
                                width: 20,
                                height: 20,
                                borderRadius: '50%',
                                backgroundColor:
                                  fornecedor.status === 1
                                    ? 'black'
                                    : fornecedor.status === 2
                                      ? 'green'
                                      : 'white',
                                border: '1px solid #ccc',
                              }}
                            />
                          </Box>
                        </TableCell>
                        <TableCell align="left" width="5">{fornecedor.descgrupomsgwhats}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
              <Box display="flex" alignItems="center" mt={2}>
                {/* Branco - Não enviado */}
                <Box display="flex" alignItems="center" mr={4}>
                  <Box
                    style={{
                      width: 16,
                      height: 16,
                      borderRadius: '50%',
                      backgroundColor: 'white',
                      border: '1px solid #ccc',
                      marginRight: 8,
                    }}
                  />
                  <Typography variant="body2" style={{ color: 'black' }}>
                    Não enviado
                  </Typography>
                </Box>

                {/* Preto - Enviado */}
                <Box display="flex" alignItems="center" mr={4}>
                  <Box
                    style={{
                      width: 16,
                      height: 16,
                      borderRadius: '50%',
                      backgroundColor: 'black',
                      marginRight: 8,
                    }}
                  />
                  <Typography variant="body2" style={{ color: 'black' }}>
                    Enviado
                  </Typography>
                </Box>

                {/* Verde - Recebido */}
                <Box display="flex" alignItems="center">
                  <Box
                    style={{
                      width: 16,
                      height: 16,
                      borderRadius: '50%',
                      backgroundColor: 'green',
                      marginRight: 8,
                    }}
                  />
                  <Typography variant="body2" style={{ color: 'black' }}>
                    Recebido
                  </Typography>
                </Box>
              </Box>
            </div>
          </TabContainer>
        }

        {/* Aba Serviços */}
        {activetab === 2 &&
          <TabContainer>
            <div>
              {!isConnected ? (
                <img src={qrCode} alt="QR Code" />
              ) : (
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#9e9e9e", // cinza
                    color: "#fff",
                    marginLeft: 16,
                  }}
                  startIcon={<ExitToAppIcon style={{ color: "#fff" }} />}
                  onClick={this.handleClickDesconectar}
                >
                  Desconectar
                </Button>
              )}
            </div>
          </TabContainer>
        }

        <div>
          <AlertInformation
            open={this.state.openAlert}
            handleClose={() => this.handleCloseAlert()}
            message={this.state.messageAlert}
          />
        </div>

        {/* Backdrop limitado a este componente */}
        {loading && (
          <Backdrop
            open={loading}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              color: '#3f51b5',
              zIndex: 1301, // pode ajustar se precisar acima de outros itens dentro do form
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(244, 246, 248, 0.7)', // leve transparência
            }}
          >
            <CircularProgress color="inherit" />
            <Typography variant="subtitle1" style={{ marginTop: 16, color: '#454545', fontSize: '14px' }}>
              {labelLoading}
            </Typography>
          </Backdrop>
        )}

      </div >


    );
  }
}

WhatsAppForm.propTypes =
{
  classes: PropTypes.object.isRequired
};
export default withStyles(styles)(WhatsAppForm);